'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _component = require('@reactions/component');

var _component2 = _interopRequireDefault(_component);

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = require('moment');
var tick = function tick(_a) {
    var setState = _a.setState,
        state = _a.state,
        endTime = _a.endTime;
    return function () {
        var durationInSeconds = moment.duration(moment(endTime).diff(moment())).asSeconds();
        var end = moment().add(durationInSeconds, 'seconds');
        var startTime = moment();
        var diff = end.diff(startTime);
        if (diff <= 0) {
            cancelAnimationFrame(state.tick);
            setState({ time: null });
            return;
        }
        var diffInSeconds = diff / 1000;
        var minutes = Math.floor(diffInSeconds / 60);
        var seconds = Math.floor(diffInSeconds - minutes * 60);
        var time = minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0');
        setState({
            tick: requestAnimationFrame(tick({ setState: setState, state: state, endTime: endTime })),
            time: time
        });
    };
};
var CountdownTimer = function CountdownTimer(_a) {
    var endTime = _a.endTime,
        children = _a.children;
    return React.createElement(_component2.default, { initialState: { time: null, endTime: endTime }, didUpdate: function didUpdate(_a) {
            var setState = _a.setState,
                state = _a.state,
                props = _a.props,
                prevProps = _a.prevProps;
            if (endTime !== state.endTime) {
                cancelAnimationFrame(state.tick);
                setState({
                    endTime: endTime,
                    tick: requestAnimationFrame(tick({ setState: setState, state: state, endTime: endTime }))
                });
            }
        }, didMount: function didMount(_a) {
            var setState = _a.setState,
                state = _a.state;
            setState({
                tick: requestAnimationFrame(tick({ setState: setState, state: state, endTime: endTime }))
            });
        }, shouldUpdate: function shouldUpdate(_a) {
            var state = _a.state,
                nextState = _a.nextState,
                nextProps = _a.nextProps;
            if (nextProps.initialState.endTime !== state.endTime) {
                return true;
            }
            return state.time !== nextState.time;
        }, willUnmount: function willUnmount(_a) {
            var state = _a.state;
            cancelAnimationFrame(state.tick);
        } }, function (_a) {
        var state = _a.state;
        return children(state);
    });
};
exports.default = CountdownTimer;
//# sourceMappingURL=CountdownTimer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/CountdownTimer/CountdownTimer.js
// module id = 1343
// module chunks = 0